import { render, staticRenderFns } from "./KSxcx.vue?vue&type=template&id=13e47696&scoped=true&"
import script from "./KSxcx.vue?vue&type=script&lang=js&"
export * from "./KSxcx.vue?vue&type=script&lang=js&"
import style0 from "./KSxcx.vue?vue&type=style&index=0&id=13e47696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e47696",
  null
  
)

export default component.exports